module.exports = __webpack_public_path__ + "img/digital-footprint.5121c64c.svg";